/**
 * Maps i18next language codes to BCP 47 locales for `Intl.*` formatters.
 * UI languages use short codes; dates and numbers use Swiss regional locales.
 */
export function intlLocaleFor(language: string): string {
  const base = language.split('-')[0];
  if (base === 'de') return 'de-CH';
  if (base === 'fr') return 'fr-CH';
  return language;
}
